import script from "./VInputCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInputCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./VInputCheckbox.vue?vue&type=style&index=0&id=53ebbf9a&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ebbf9a"]])

export default __exports__